import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbainashikcab() {



  const cardData = {
    keyword: " Mumbai Nashik Cab ",



"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Nashik cab services, ensuring a smooth, safe, and enjoyable journey for families, pilgrims, wine tour travelers, and weekend explorers. Whether you are planning a religious visit to Trimbakeshwar, a vineyard tour, or a relaxing getaway, our professional drivers and well-maintained vehicles guarantee a stress-free travel experience. The Mumbai to Nashik route covers approximately 165 to 180 km and takes around 3.5 to 4.5 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Nashik travel.",

"topPlaces": [
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous winery located in Nashik, known for wine tasting tours, vineyard walks, and scenic sunset views. Visitors can enjoy premium wines, live events, and relaxing weekend experiences surrounded by lush grape plantations."
  },
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva. It is a highly sacred pilgrimage site where devotees perform rituals like Kaal Sarp Dosh Puja and seek spiritual blessings in a powerful divine atmosphere."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a historic and religious area linked to the Ramayana, where Lord Rama, Sita, and Lakshmana are believed to have stayed during exile. It is home to ancient temples, ghats, and spiritually significant landmarks."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a sacred bathing ghat on the Godavari River where devotees perform holy rituals and dips. It is believed that Lord Rama bathed here, making it one of Nashik’s most important spiritual sites."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "Pandav Leni Caves are ancient rock-cut Buddhist caves dating back to the 1st century BC. They feature carvings, meditation halls, and inscriptions, making them a peaceful historical attraction."
  },
  {
    "title": "Anjneri Hill",
    "description": "Anjneri Hill is believed to be the birthplace of Lord Hanuman. It is a popular trekking destination offering scenic views, greenery, and a peaceful atmosphere for nature lovers."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Someshwar Waterfall is a beautiful natural attraction located near Nashik, especially scenic during monsoon season. It is a popular picnic spot for families and nature enthusiasts."
  },
  {
    "title": "Saptashrungi Temple",
    "description": "Saptashrungi Devi Temple is a famous hilltop temple dedicated to Goddess Durga. It offers spiritual significance along with stunning views of the surrounding hills."
  },
  {
    "title": "Coin Museum",
    "description": "The Coin Museum in Nashik showcases India’s rich numismatic history with ancient coins, exhibits, and educational displays, making it a unique attraction for history lovers."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam is a peaceful water reservoir near Nashik, known for scenic views, calm surroundings, and sunset spots ideal for relaxing and photography."
  }
],







services: [
  {
    name: "Mumbai to Nashik Cab",
    description: "Mumbai to Nashik cab service offers a comfortable and reliable travel experience for families, tourists, and business travelers. Professional drivers, well-maintained vehicles, and flexible pickup options ensure a smooth journey. Travelers can choose from sedan, SUV, and luxury cars according to their needs. It provides safe and hassle-free transportation between Mumbai and Nashik."
  },
  {
    name: "Mumbai to Nashik Taxi",
    description: "Mumbai to Nashik taxi provides convenient door-to-door transportation for all types of travelers. Clean vehicles and experienced drivers ensure a safe and pleasant journey. The service is suitable for one-way and round-trip travel. Flexible scheduling and affordable pricing make it a preferred travel option."
  },
  {
    name: "Mumbai to Nashik Cab Service",
    description: "Mumbai to Nashik cab service is designed to provide comfortable long-distance travel with professional chauffeurs and quality vehicles. Travelers can enjoy flexible pickup and drop locations. The service is ideal for personal, family, and corporate trips. It ensures a reliable and stress-free journey."
  },
  {
    name: "Mumbai to Nashik Taxi Service",
    description: "Mumbai to Nashik taxi service offers dependable transportation with a focus on comfort and safety. Vehicles are regularly maintained for long-distance travel. Customers can select from multiple vehicle categories based on their requirements. It guarantees a smooth and enjoyable travel experience."
  },
  {
    name: "Cab from Mumbai to Nashik",
    description: "Cab from Mumbai to Nashik is a convenient travel option for tourists, families, and business travelers. Doorstep pickup and drop services make the journey hassle-free. Comfortable vehicles and experienced drivers ensure safe highway travel. It provides a flexible and private travel experience."
  },
  {
    name: "Taxi from Mumbai to Nashik",
    description: "Taxi from Mumbai to Nashik offers comfortable transportation with professional drivers and well-maintained vehicles. The service is available for one-way and round-trip journeys. Customers can enjoy a smooth ride with flexible travel timings. It ensures reliable travel between the two cities."
  },
  {
    name: "Mumbai to Nashik Cab Booking",
    description: "Mumbai to Nashik cab booking allows travelers to reserve their ride quickly and conveniently. Customers can choose their preferred vehicle type and travel schedule. Instant confirmation and transparent pricing simplify travel planning. It ensures a hassle-free booking experience."
  },
  {
    name: "Mumbai to Nashik Taxi Booking Online",
    description: "Mumbai to Nashik taxi booking online offers a fast and secure way to reserve your cab from anywhere. Travelers can compare vehicle options and confirm bookings instantly. The process is simple, convenient, and available round the clock. It ensures easy travel planning."
  },
  {
    name: "Mumbai to Nashik Cab Price",
    description: "Mumbai to Nashik cab price depends on vehicle type, trip duration, and travel requirements. Customers can choose from economical and premium options. Transparent pricing ensures no hidden charges. It helps travelers find the best travel solution within their budget."
  },
  {
    name: "Mumbai to Nashik Taxi Fare",
    description: "Mumbai to Nashik taxi fare is designed to provide affordable and transparent pricing for travelers. Fare may vary depending on the vehicle category and travel plan. Clear cost details are provided before booking. It ensures confidence and value for money."
  },
  {
    name: "Mumbai to Nashik One Way Cab",
    description: "Mumbai to Nashik one way cab is a cost-effective travel option for passengers requiring a single-side drop. This service eliminates unnecessary return charges and offers flexible pickup timings. Comfortable vehicles and experienced drivers ensure a pleasant journey."
  },
  {
    name: "Mumbai to Nashik Round Trip Taxi",
    description: "Mumbai to Nashik round trip taxi is ideal for travelers planning a return journey on the same or a later date. The package includes pickup, drop, waiting time, and return travel. It offers convenience, flexibility, and cost savings for families and groups."
  },
  {
    name: "Mumbai to Nashik Innova Cab",
    description: "Mumbai to Nashik Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space for long-distance journeys. Professional drivers ensure a safe and smooth ride. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Nashik Ertiga Cab",
    description: "Mumbai to Nashik Ertiga cab is an excellent choice for group travel with comfortable seating and modern amenities. It offers a balance of affordability and comfort. Suitable for family trips and business travel. It ensures a relaxed and enjoyable journey."
  },
  {
    name: "Mumbai to Nashik Sedan Cab",
    description: "Mumbai to Nashik sedan cab is ideal for individuals, couples, and small families seeking economical travel. Sedans offer comfortable seating, smooth rides, and fuel-efficient transportation. It is a popular choice for business and leisure travel."
  },
  {
    name: "Mumbai to Nashik SUV Taxi",
    description: "Mumbai to Nashik SUV taxi provides spacious and comfortable travel for larger groups and travelers carrying extra luggage. SUVs offer enhanced comfort on long-distance routes. It is suitable for family vacations, corporate travel, and group outings."
  },
  {
    name: "Cheap Mumbai to Nashik Cab",
    description: "Cheap Mumbai to Nashik cab service offers budget-friendly transportation without compromising on comfort and safety. Travelers can choose affordable vehicle options with transparent pricing. It is ideal for cost-conscious passengers seeking reliable travel."
  },
  {
    name: "Best Mumbai to Nashik Taxi Service",
    description: "Best Mumbai to Nashik taxi service combines comfort, reliability, and professional customer support. Well-maintained vehicles, experienced chauffeurs, and transparent pricing ensure a premium travel experience. It is suitable for families, tourists, and business travelers."
  }
],

tableData: [
  ["Mumbai to Nashik Cab", "Mumbai to Nashik Taxi"],
  ["Mumbai to Nashik Cab Service", "Mumbai to Nashik Taxi Service"],
  ["Cab from Mumbai to Nashik", "Taxi from Mumbai to Nashik"],
  ["Mumbai to Nashik Cab Booking", "Mumbai to Nashik Taxi Booking Online"],
  ["Mumbai to Nashik Cab Price", "Mumbai to Nashik Taxi Fare"],
  ["Mumbai to Nashik One Way Cab", "Mumbai to Nashik Round Trip Taxi"],
  ["Mumbai to Nashik Innova Cab", "Mumbai to Nashik Ertiga Cab"],
  ["Mumbai to Nashik Sedan Cab", "Mumbai to Nashik SUV Taxi"],
  ["Cheap Mumbai to Nashik Cab", "Best Mumbai to Nashik Taxi Service"],
  ["Mumbai to Nashik Cab", "Mumbai to Nashik Taxi"],
  ["Mumbai to Nashik Cab Service", "Cab from Mumbai to Nashik"],
  ["Taxi from Mumbai to Nashik", "Mumbai to Nashik Cab Booking"],
  ["Mumbai to Nashik Taxi Booking Online", "Mumbai to Nashik Cab Price"],
  ["Mumbai to Nashik Taxi Fare", "Mumbai to Nashik One Way Cab"],
  ["Mumbai to Nashik Round Trip Taxi", "Mumbai to Nashik Innova Cab"],
  ["Mumbai to Nashik Ertiga Cab", "Mumbai to Nashik Sedan Cab"],
  ["Mumbai to Nashik SUV Taxi", "Cheap Mumbai to Nashik Cab"],
  ["Best Mumbai to Nashik Taxi Service", "Mumbai to Nashik Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Shirdi Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and peaceful Mumbai to Shirdi cab service, ideal for devotees, families, and group pilgrimages."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our drivers are skilled in Mumbai to Shirdi routes, ensuring safe driving, proper navigation, and timely arrival for darshan."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs without any hidden fees."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Shirdi cab service is available 24/7, allowing flexible travel for early morning or overnight darshan trips."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return packages for Shirdi darshan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Shirdi cab bookings due to punctual service, safe travel, and reliable drivers."
  }
]

};

const faqData = [
  {
    question: "Why choose Royal Route Cabs for Mumbai to Nashik travel?",
    answer: "Royal Route Cabs offers dependable transportation with well-maintained vehicles, professional drivers, and flexible travel options for every passenger."
  },
  {
    question: "Does Royal Route Cabs provide one-way taxi service from Mumbai to Nashik?",
    answer: "Yes, Royal Route Cabs offers affordable one-way taxi services for customers traveling from Mumbai to Nashik."
  },
  {
    question: "Can I book a round-trip cab with Royal Route Cabs?",
    answer: "Yes, travelers can choose round-trip packages with convenient return scheduling according to their travel plans."
  },
  {
    question: "What vehicle categories are available for this route?",
    answer: "Royal Route Cabs provides sedans, MUVs, premium SUVs, and Tempo Travellers to suit different group sizes and budgets."
  },
  {
    question: "Is Mumbai Airport pickup available for Nashik trips?",
    answer: "Yes, Royal Route Cabs offers airport transfers from Mumbai Airport directly to Nashik with timely pickup service."
  },
  {
    question: "How early should I reserve my Mumbai to Nashik cab?",
    answer: "While instant bookings are accepted based on availability, advance reservations help ensure your preferred vehicle is available."
  },
  {
    question: "Are the cabs suitable for corporate travel?",
    answer: "Yes, Royal Route Cabs caters to business travelers with comfortable vehicles and punctual service for corporate journeys."
  },
  {
    question: "Do drivers have experience on the Mumbai–Nashik route?",
    answer: "Yes, our drivers are experienced and regularly operate on the Mumbai–Nashik highway, ensuring a safe and efficient journey."
  },
  {
    question: "Can I travel to Nashik for religious and sightseeing tours?",
    answer: "Yes, Royal Route Cabs provides transportation for temple visits, vineyard tours, family outings, and sightseeing trips in Nashik."
  },
  {
    question: "Does Royal Route Cabs offer customer support during the trip?",
    answer: "Yes, our support team remains available to assist passengers before and during their journey whenever required."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Kulkarni",
    feedback:
      "I booked Royal Route Cabs for a Mumbai to Nashik business trip. The driver was punctual, the car was spotless, and the overall experience exceeded my expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Miss. Priya Deshmukh",
    feedback:
      "Royal Route Cabs made our Nashik family tour comfortable and stress-free. The booking process was simple, and the journey was smooth from start to finish.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nashik Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-nashik-cab.jpg", // replace if needed
  "description": "Book Mumbai to Nashik cab with Royal Route Cabs for a comfortable and affordable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel. 24x7 taxi service with professional drivers ensures a safe ride.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-nashik-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Mumbai to Nashik Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Nashik cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to nashik cab, mumbai to nashik taxi, mumbai to nashik cab service, mumbai to nashik taxi service, cab from mumbai to nashik, taxi from mumbai to nashik, mumbai to nashik cab booking, mumbai to nashik taxi booking online, mumbai to nashik cab price, mumbai to nashik taxi fare, mumbai to nashik one way cab, mumbai to nashik round trip taxi, mumbai to nashik innova cab, mumbai to nashik ertiga cab, mumbai to nashik sedan cab, mumbai to nashik suv taxi, cheap mumbai to nashik cab, best mumbai to nashik taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbainashikcab;